module.exports = __webpack_public_path__ + "static/media/litho-3.66832d70.jpg";